require('./bootstrap');

import '../plugins/vue-composition-api';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import vuetify from './vuetify';
import store from './store';

import Head, { createInertiaApp, Link, plugin } from '@inertiajs/inertia-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { InertiaProgress } from '@inertiajs/progress';

Vue.use(VueCompositionAPI);
Vue.use(VueAxios, axios);
Vue.use(plugin);

Vue.prototype.$route = route;

InertiaProgress.init({
	color: '#9155fd',
});

createInertiaApp({
	title: (title) => `${title} - PDA Invent`,
    resolve: async (name) => {
        return await import(`./Pages/${name}`);
    },
	setup({ el, App, props }) {
		new Vue({
			store,
			vuetify: vuetify,
			render: (h) => h(App, props),
			components: {
				InertiaHead: Head,
				InertiaLink: Link,
			},
			mounted() {
				const theme = localStorage.getItem('dark_theme');
				if (theme) {
					if (theme === 'true') {
						this.$vuetify.theme.dark = true;
					} else {
						this.$vuetify.theme.dark = false;
					}
				}
			},
		}).$mount(el);
	},
});
